
import Vue from 'vue'
import _ from 'lodash'
import { DEFAULT_PAGE_SIZE } from '@/config/app'
import { i18n } from '@/i18n'

const getDefaultState = () => {
  return {
    paginationInfo: {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: null,
    order: null,
    filters: [],
    notificationsNumber: {},
    masterFilters: {
      created_at_from: { label: 'Creado desde', value: '' },
      created_at_to: { label: 'Creado hasta', value: '' },
      expires_from: { label: 'Expira desde', value: '' },
      expires_to: { label: 'Espira hasta', value: '' },
      name: { label: 'Nombre', value: '' },
      serial: { label: 'Serial', value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
      tipoCert: { label: i18n.t('certificates.type'), value: '' }
    },
    notUseLikeTags: ['results', 'page', 'sort', 'order', 'status'],
    kendo: {
      columns: [
        { field: 'selected', width: '50px', minResizableWidth: 50, headerSelectionValue: false, locked: true, reorderable: false, groupable: false },
        {
          field: 'Distribuidor',
          title: i18n.t('distributors.distributor'),
          columnMenu: 'myTemplate',
          hidden: true,
          locked: false,
          width: '180px',
          minResizableWidth: 130
        },
        { field: 'Empresa', width: '450px', minResizableWidth: 338, title: i18n.t('app.client'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'CommonName', width: '450px', minResizableWidth: 338, title: i18n.t('certificates.name'), columnMenu: 'myTemplate', locked: false },
        { field: 'HashPFX', width: '450px', minResizableWidth: 338, title: i18n.t('certificates.serial'), columnMenu: 'myTemplate', locked: false },
        { field: 'CertFechaCaducidad', width: '250px', minResizableWidth: 188, title: i18n.t('certificates.expires_at'), type: 'date', filter: 'date', format: '{0:dd-MM-yyyy HH:mm }', columnMenu: 'myTemplate', locked: false },
        { field: 'TipoCertificadoNombre', width: '285px', minResizableWidth: 214, title: i18n.t('certificates.type'), columnMenu: 'myTemplate', locked: false },
        { field: 'TipoCertificado', width: '150px', minResizableWidth: 100, title: i18n.t('certificates.cod_type'), columnMenu: 'myTemplate', locked: false, hidden: true },
        { field: 'IdEmpresa', width: '100px', minResizableWidth: 50, title: i18n.t('companies.id_client'), columnMenu: 'myTemplate', locked: false, hidden: true },
        // { field: 'selected', width: 50, minWidth: 50, headerSelectionValue: this.areAllSelected, locked: true, reorderable: false, groupable: false },
        // { field: 'Empresa', minWidth: 200, title: i18n.t('app.client'), columnMenu: 'myTemplate', locked: false, hidden: true },
        // { field: 'CommonName', minWidth: 200, title: i18n.t('certificates.name'), columnMenu: 'myTemplate', locked: false },
        // { field: 'HashPFX', minWidth: 200, title: i18n.t('certificates.serial'), columnMenu: 'myTemplate', locked: false },
        // { field: 'CertFechaCaducidad', minWidth: 200, title: i18n.t('certificates.expires_at'), type: 'date', filter: 'date', format: '{0:dd-MM-yyyy HH:mm }', columnMenu: 'myTemplate', locked: false },
        // { field: 'TipoCertificado', minWidth: 200, title: i18n.t('certificates.type'), columnMenu: 'myTemplate', locked: false },
        // { field: 'IdEmpresa', width: 100, minWidth: 100, title: i18n.t('companies.id_client'), columnMenu: 'myTemplate', locked: false, hidden: true }
      ],
      skip: 0,
      take: 10,
      sortable: true,
      filterable: false,
      groupable: true,
      sort: [],
      group: [],
      filter: null,
      columnMenu: true,
      dataResult: null,
      links: [],
      navigate: true
    },
  }
}

const state = getDefaultState()

const getters = {
  getKendo: state => state.kendo,
  getPayloadCurrentPage: state => state.paginationInfo.currentPage,
  getPayloadPageSize: state => state.paginationInfo.pageSize,
  getPayloadTotal: state => state.paginationInfo.total,
  getPayLoadTotalPages: state => state.paginationInfo.totalPages,
  getMasterFilters: state => state.masterFilters,
  getCurrentPage: state => state.currentPage,
  getPageSize: state => state.pageSize,
  getNotificationsNumber: state => state.notificationsNumber,
  getPaginationInfo: state => {
    state.paginationInfo.pageSize = state.pageSize
    return state.paginationInfo
  },
  getFilters: (state) => {
    state.filters.results = state.pageSize
    state.filters.page = state.currentPage
    if (state.order) {
      state.filters.order = state.order
    } else {
      delete (state.filters.order)
    }
    if (state.sort && state.filters.order) {
      state.filters.sort = state.sort
    } else {
      delete (state.filters.sort)
    }
    return state.filters
  },
  getTags: (state) => {
    const tags = []
    _.each(state.filters, (item, key) => {
      if (state.notUseLikeTags.indexOf(key) === -1) {
        tags.push([key, item.label, item.value])
        /*
        if (Array.isArray(item)) {
          _.each(item, (item2, key2) => {
            const _temp = Object.keys(item2)[0]
            if (state.notUseLikeTags.indexOf(_temp) === -1) {
              tags.push([key + '.' + _temp, Object.values(item2)[0]])
            }
          })
        } else {
          tags.push([key, item])
        }
        */
      }
    })
    return tags
  },
  getAppliedFilters (state) {
    const data = {}
    const _temp = Object.entries(state.masterFilters)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.filters = data
    return data
  }
}

const mutations = {
  setKendoColumns (state, data) {
    data.unshift('selected')
    state.kendo.columns = state.kendo.columns.map(x => {
      if (data.includes(x.field)) {
        x.hidden = false
      } else {
        x.hidden = true
        data.push(x.field)
      }
      return x
    }).sort((a, b) => data.indexOf(a.field) - data.indexOf(b.field))
  },
  setKendo (state, kendo) {
    state.kendo = kendo
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  resetStateWithoutSort (state, data) {
    Object.assign(state, getDefaultState())
    // Object.assign(state, getDefaultState())
    state.kendo.sort = data.sort
    state.kendo.group = data.group
  },
  resetPaginationInfo (state, data) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.paginationInfo = {
      total: 0,
      currentPage: 1,
      totalPages: 0,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  setPaginationInfo (state, data) {
    state.paginationInfo = data
  },
  setSort (state, fieldName) {
    state.sort = fieldName
  },
  setSortOrder (state, order) {
    switch (order) {
      case 'ascending':
        state.order = 'asc'
        break
      case 'descending':
        state.order = 'desc'
        break
      default:
        state.order = null
        state.sort = null
    }
  },
  setNotUseLikeTags (state, items = []) {
    state.notUseLikeTags = items
  },
  setMasterFilters (state, master) {
    const data = {}
    const _temp = Object.entries(master)
    _.each(_temp, (item) => {
      if (item[1].value !== '') data[item[0]] = item[1]
    })
    state.masterFilters = data
    // console.log(data)
  },
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber () {
    state.notificationsNumber = {}
  },
  removeTag (state, tag) {
    const path = tag.split('.')
    if (path.length === 1) {
      state.masterFilters[path[0]] = ''
    }
    if (path.length === 2) {
      state.masterFilters[path[0]][path[1]] = ''
    }
  },
  resetMasterFilters (state) {
    state.masterFilters = {
      created_at_from: { label: 'Creado desde', value: '' },
      created_at_to: { label: 'Creado hasta', value: '' },
      expires_from: { label: 'Expira desde', value: '' },
      expires_to: { label: 'Espira hasta', value: '' },
      name: { label: 'Nombre', value: '' },
      serial: { label: 'Serial', value: '' },
      empresa: { label: i18n.t('app.client'), value: '' },
      tipoCert: { label: i18n.t('certificates.type'), value: '' }
    }
  },
  setFilter (state, { key, value }) {
    Vue.set(state.filters, { key: value })
  },
  setFilters (state, thefilters) {
    Vue.set(state, 'filters', thefilters)
  },
  clearFilters (state) {
    Vue.set(state, 'filters', [])
  },
  clearPagination (state) {
    state.pageSize = DEFAULT_PAGE_SIZE
    state.currentPage = 1
  },
  setPageSize (state, size) {
    state.pageSize = size
  },
  setCurrentPage (state, pageNumner) {
    if (pageNumner > 0 && pageNumner <= state.paginationInfo.totalPages) {
      state.currentPage = pageNumner
      state.paginationInfo.currentPage = pageNumner
    }
  }
}

const actions = {
  resetCartState ({ commit }) {
    commit('resetState')
  },
  resetStateWithoutSort ({ commit, rootGetters }) {
    const data = {
      sort: rootGetters['trashCertificatesPersisted/getSort'],
      group: rootGetters['trashCertificatesPersisted/getGroup'],
    }
    commit('resetStateWithoutSort', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
